import { SyncSelection } from "./types";

// Matches the h-14 on SyncSelectionRow, so FixedSizeList never has to measure a row.
export const ROW_HEIGHT = 56;
export const MAX_VISIBLE_ROWS = 10;
export const OVERSCAN = 8;

export const EMPTY_SELECTIONS: SyncSelection[] = [];

// Reserves the list's scrollbar width on the header too, so columns stay aligned where scrollbars take up space.
export const LIST_GUTTER_CLASS = "[scrollbar-gutter:stable]";

export const ROW_CLASS = "flex items-center gap-x-6 px-6";
export const NAME_COLUMN_CLASS = "flex flex-1 min-w-0 items-center gap-x-3";
export const SIZE_COLUMN_CLASS = "w-32 shrink-0";
export const STATUS_COLUMN_CLASS = "w-32 shrink-0";
export const TYPE_COLUMN_CLASS = "w-48 shrink-0";
export const UPDATED_COLUMN_CLASS = "w-40 shrink-0";
